import React, { useCallback, useEffect } from 'react';
import styles from '../index.module.sass';
import OnBoardingLayout from 'layout/onboarding';
import Button from 'components/button';
import FormInput from 'components/form-input';
import OtpButton from 'components/otp-button';
import {
  useLoginFlowContext,
  CHANGE_OTP,
  CHANGE_MOBILE,
  OTP_TIMES_UP,
  CHANGE_MOBILE_ERROR_MESSAGE,
  CHANGE_OTP_ERROR_MESSAGE,
} from 'feature/login-flow/use-login-flow';
import { privacyUrl, termsUrl, payTaipeiCardlessParkingTermsUrl } from 'config';
import link from 'assets/icon_link.svg';
import amplitude from 'service/amplitude';
import { isCitimkt } from 'config';

const LoginPage = () => {
  const { state, dispatch, fetchOtp, login } = useLoginFlowContext();

  useEffect(() => {
    amplitude.login_pageview();
  }, []);

  useEffect(() => {
    return () => {
      dispatch({
        type: CHANGE_MOBILE_ERROR_MESSAGE,
        payload: '',
      });

      dispatch({
        type: CHANGE_OTP_ERROR_MESSAGE,
        payload: '',
      });
    };
  }, [dispatch]);

  const onMobileChanged = useCallback(
    phone => {
      dispatch({
        type: CHANGE_MOBILE,
        payload: phone,
      });
    },
    [dispatch]
  );

  const onOtpChanged = useCallback(
    phone => {
      dispatch({
        type: CHANGE_OTP,
        payload: phone,
      });
    },
    [dispatch]
  );

  const onOtpClick = useCallback(() => {
    amplitude.login_sendOtp_onClick();
    fetchOtp(state.mobile);
  }, [state, fetchOtp]);

  const onOtpTimesUp = useCallback(() => {
    dispatch({ type: OTP_TIMES_UP });
  }, [dispatch]);

  const onLogin = useCallback(() => {
    amplitude.login_button_onClick();
    login(state.mobile, state.otp);
  }, [state, login]);

  return (
    <OnBoardingLayout className={styles['login']}>
      <div className={styles.top}>
        <div className={styles.link}>
          連結
          <img src={link} alt="link" />
          Autopass
        </div>
        <div className={styles.title}>手機就是你的帳號</div>
        <div className={styles.desc}>簡訊驗證快速登入，不需額外記密碼</div>
        <div className={styles.form}>
          <FormInput
            onFocus={() => amplitude.login_mobile_onClick()}
            disabled={isCitimkt}
            type="tel"
            value={state.mobile}
            placeholder="輸入手機號碼 09··"
            digits="[0-9]"
            maxLength={10}
            onTextChanged={onMobileChanged}
            errorMessage={state.mobileErrorMessage}
            button={
              <OtpButton
                enabled={state.mobile.length === 10}
                onClick={onOtpClick}
                startCountDown={state.startCountDownOtp}
                onTimesUp={onOtpTimesUp}
              >
                傳送驗證碼
              </OtpButton>
            }
          />
          <FormInput
            inputMode="numeric"
            onFocus={() => amplitude.login_otp_onClick()}
            value={state.otp}
            placeholder="輸入簡訊驗證碼"
            digits="[0-9]"
            maxLength={6}
            onTextChanged={onOtpChanged}
            errorMessage={state.otpErrorMessage}
          />
        </div>
      </div>
      <div className={styles.bottom}>
        <Button theme="blue" block={true} loading={state.loading} onClick={onLogin}>
          登入 / 註冊
        </Button>
        <div className={styles.aggreement}>
          使用及註冊麻吉付，即代表同意
          <br />
          <a href={termsUrl}>服務條款</a> / <a href={privacyUrl}>隱私權政策</a> /{' '}
          <a href={payTaipeiCardlessParkingTermsUrl}>北市停車條款</a>
        </div>
      </div>
    </OnBoardingLayout>
  );
};

export default LoginPage;
